<template>
  <hero-image :blockField="data">
    <template slot="title">{{ data.title.data }}</template>
    <template slot="subtitle">{{data.subtitle.data }}</template>
  </hero-image>
</template>
<script>
  import blockProperties from '@fremcast/section/mixins/blockProperties';

  export default {
    mixins: [
      blockProperties
    ]
  }
</script>
